<template>
  <div class="">
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div>
        <h2 class="text-xl font-semibold text-gray-800">Global Settings</h2>
      </div>
      <button
        @click="getSettings"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-1.5 rounded-lg shadow transition"
      >
        <span class="material-icons text-base capitalize">refresh</span>
        Refresh
      </button>
    </div>
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white p-3">
      <vs-col>
        <vs-input label="Radius for user-search and events" type="number" v-model="data.radius" />
      </vs-col>
      <vs-col>
        <vs-input label="Firebase api_key" type="text" v-model="data.api_key" />
      </vs-col>
      <vs-col>
        <vs-input label="View count for popular events" type="number" v-model="data.viewCount" />
      </vs-col>
      <vs-col class="mb-3">
        <vs-select label="Translation API" v-model="data.translateAPI">
          <vs-select-item value="Select service" text="Select service" disabled>Select service</vs-select-item>
          <vs-select-item
            v-for="item in ['google1', 'google2', 'gpt', 'kriesler g-translate']"
            :key="item"
            :value="item"
            :text="item"
          ></vs-select-item>
        </vs-select>
        <div class="mt-1 text-sm text-gray-500">
          ^ In case 'google1' does not work, try 'google2', if both do not work, try 'kreiser g-translate'.
        </div>
      </vs-col>
      <vs-button @click="save" class="w-20"> Save </vs-button>
      <hr />
      <!-- extra doc info -->
      <p class="font-bold text-lg">Documentation:</p>
      <div class="mt-2">
        <a
          href="https://www.notion.so/Notification-Tutorial-Kundali-PDF-key-6a124d5289844584a8778423c0bc2d86"
          target="_blank"
          class="text-indigo-600 hover:underline"
        >
          Notification Tutorial & Kundli Keys
        </a>
      </div>
      <div class="mt-2">
        <a
          href="https://docs.google.com/spreadsheets/d/1mwVXKzTZARtIZxwn_SawePXwEYwnlSEpRUPNwbM4LBY/edit?gid=0#gid=0"
          target="_blank"
          class="text-indigo-600 hover:underline"
          >Notification key-value pairs</a
        >
      </div>
      <div class="mt-2">
        <a href="https://www.notion.so/UserProperty-03f3718085da48bc9cbdcca8872ff4d2" target="_blank" class="text-indigo-600 hover:underline"
          >User Properties</a
        >
      </div>
      <div class="mt-2">
        <a
          href="https://www.notion.so/FirebaseRemoteConfig-c13a7e37772749ef8a50166d5cf98640?pm=c"
          target="_blank"
          class="text-indigo-600 hover:underline"
          >Firebase Remote Config</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/rest.js";
import { API } from "@/common/constants";

export default {
  name: "settings",
  data: () => ({
    data: {
      radius: "",
      api_key: "",
      viewCount: "",
      translateAPI: "Select service",
    },
  }),
  computed: {},
  methods: {
    async save() {
      this.$vs.loading();
      try {
        const r = await api.post(API.SETTINGS, this.$data.data);
        if (r.status === 200) {
          this.$ls.set("api_settings", JSON.stringify(this.$data.data));

          this.$vs.notify({
            text: "Settings Updated Successfully!",
            color: "success",
            position: "right",
          });
          await this.getSettings();
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Settings save error",
          text: r.data.error,
          color: "danger",
          position: "right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async getSettings() {
      this.$vs.loading();
      try {
        const r = await api.get(API.SETTINGS);
        if (r.status === 200) {
          this.$data.data = r.data;
          this.$ls.set("api_settings", JSON.stringify(r.data));
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Settings fetch error",
          text: r.data.error,
          color: "danger",
          position: "right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    await this.getSettings();
  },
};
</script>
<style scoped></style>
